import { cn } from "@/lib/utils";
import { QrCode } from "lucide-react";

interface QrCodeMarkProps {
  // xs: inline in a step card; sm/md: on a stand or phone screen; lg: hero.
  size?: "xs" | "sm" | "md" | "lg";
  className?: string;
}

const sizeClass = {
  xs: { tile: "rounded-md p-1", icon: "size-6" },
  sm: { tile: "rounded-lg p-1.5", icon: "size-16" },
  md: { tile: "rounded-xl p-2", icon: "size-24" },
  lg: { tile: "rounded-2xl p-2.5", icon: "size-full" },
};

// The one QR code drawing on the site: the lucide QrCode mark on a white
// tile. Decorative - the text around it says what it is.
const QrCodeMark = ({ size = "md", className }: QrCodeMarkProps) => (
  <span
    aria-hidden="true"
    className={cn(
      "inline-grid place-items-center bg-white text-ink",
      sizeClass[size].tile,
      className,
    )}
  >
    <QrCode className={sizeClass[size].icon} strokeWidth={1.6} />
  </span>
);

export default QrCodeMark;
